var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"modal__form"},[_c('FormInput',{attrs:{"name":"Título","placeholder":"Título"},model:{value:(_vm.item.title),callback:function ($$v) {_vm.$set(_vm.item, "title", $$v)},expression:"item.title"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }